import type { BackendDefinition } from '../../Connectware'

/**
 * Resource as represented on the backend
 */
type BackendResource = BackendDefinition<'service-manager', 'Resource'>
export type ResourceCategories = BackendResource['category']
type ResourceProtocols = BackendResource['protocol']

export type Resource<Category extends ResourceCategories = ResourceCategories, Protocol extends ResourceProtocols = ResourceProtocols> =
    /** For protocol, using extract is needed */
    Extract<
        /** For category, a simple intersection is needed */
        BackendResource & { category: Category },
        { protocol: Protocol }
    >

export const isResource = <C extends ResourceCategories>(resource: Resource, ...categories: readonly C[]): resource is Resource<C> =>
    categories.some((c) => resource.category === c)

export const isResourceOfProtocol = <C extends ResourceCategories, P extends ResourceProtocols>(
    resource: Resource,
    category: C,
    protocol: P
): resource is Resource<C, P> => isResource(resource, category) && resource.protocol === protocol
